<template>
    <div class="day-filter-buttons">
        <vs-button-group>
            <vs-button
                v-for="option in options"
                :key="option.value"
                :color="value === option.value ? 'primary' : 'dark'"
                :type="value === option.value ? 'filled' : 'line'"
                size="small"
                @click="handleClick(option.value)"
            >
                {{ option.label }}
            </vs-button>
        </vs-button-group>
    </div>
</template>

<script>
/**
 * 날짜 필터 버튼 컴포넌트
 * @description cure, injection 페이지에서 공통 사용
 *
 * @example
 * <DayFilterButtons
 *     :value="dayFilter"
 *     @change="changeDayFilter"
 * />
 */
import { DAY_FILTER_BUTTONS } from '@/constants/dayFilter';

export default {
    name: 'DayFilterButtons',

    props: {
        /**
         * 현재 선택된 날짜 필터 값
         * @type {number}
         */
        value: {
            type: Number,
            required: true
        },

        /**
         * 버튼 옵션 배열
         * @type {Array<{value: number, label: string}>}
         */
        options: {
            type: Array,
            default: () => DAY_FILTER_BUTTONS
        }
    },

    methods: {
        /**
         * 버튼 클릭 핸들러
         * @param {number} newValue - 선택된 필터 값
         */
        handleClick(newValue) {
            if (this.value !== newValue) {
                this.$emit('input', newValue);
                this.$emit('change', newValue);
            }
        }
    }
};
</script>

<style scoped>
.day-filter-buttons {
    display: inline-block;
    margin-left: 16px;
}
</style>
